import clsx from "clsx";
import Tooltip from "components/Tooltip";

interface DashboardSimpleNumberProps {
  value?: number | string | null | undefined;
  title?: string;
  subtitle?: string;
  unit?: string | React.ReactNode;
  className?: string;
  valueClassName?: string;
  suffix?: string;
  tooltip?: string;
}

export function modulesPerCertification(certificationName?: string) {
  const moduleList18 = ["A1-A3", "B4", "C3", "C4", "D"];
  const moduleListLevels = ["A1-A3", "C3", "C4"];
  const moduleList = ["A1-A3", "B4", "C3", "C4"];
  let relevant = moduleList;

  if ((certificationName || "").includes("18")) {
    relevant = moduleList18;
  } else if ((certificationName || "").toLowerCase().includes("level")) {
    relevant = moduleListLevels;
  }
  return relevant;
}

export function tooltipModuleList(
  t: Function,
  certificationName?: string,
  modulesList?: string[]
): string {
  const modules = modulesList ?? modulesPerCertification(certificationName);
  const relevant = modules.join(", ");

  return t("dashboard.tooltipModuleList", { list_of_modules: relevant });
}

export default function DashboardSimpleNumber(
  props: DashboardSimpleNumberProps
) {
  const getValue = () => {
    const fixedValue = Number(props.value).toFixed(2);
    const valueFixedToZero =
      Number(props.value) > 0 && Number(fixedValue) === 0;
    if (valueFixedToZero) {
      return <Tooltip content={props.value}>{`${fixedValue}..`}</Tooltip>;
    }
    return fixedValue;
  };

  return (
    <div className={clsx("w-full flex flex-col text-center", props.className)}>
      {props.title && <h3 className="text-md">{props.title}</h3>}
      {props.subtitle && <h4 className="text-xs">{props.subtitle}</h4>}
      {props.value !== null && (
        <h3 className="font-bold text-xl flex justify-center">
          {getValue()}
          {props.suffix && props.suffix}
          {props.tooltip && <Tooltip content={props.tooltip} />}
        </h3>
      )}
      {props.unit && <h3 className="text-xs">{props.unit}</h3>}
    </div>
  );
}
